import { observer } from 'mobx-react-lite'
import { Id } from '@/infra/id'
import { type WorkspaceSignupViewModel } from '@/features/iam/workspaces/WorkspaceSignup/WorkspaceSignupViewModel'
import { WorkspaceSelector } from '@/features/iam/workspaces/WorkspaceSelector'
import { type WorkspaceSelectorViewModel } from './WorkspaceSelectorViewModel'

export interface WorkspaceSelectorContainerProps {
  vm: WorkspaceSelectorViewModel
  workspaceSignupVm: WorkspaceSignupViewModel
}

export const WorkspaceSelectorContainer = observer(
  function WorkspaceSelectorContainer({
    vm,
    workspaceSignupVm,
  }: WorkspaceSelectorContainerProps) {
    return (
      <WorkspaceSelector
        isOpen={vm.selector.showing}
        showDefaultToAllWorkspaces={vm.showDefaultToAllWorkspaces}
        isDefaultToAllWorkspaces={vm.isDefaultToAllWorkspaces}
        onToggleDefaultToAllWorkspaces={vm.toggleDefaultToAllWorkspaces}
        searchText={vm.searchText}
        onSearchTextChange={vm.setSearchText}
        workspaces={vm.filteredMemberships.map(({ workspace }) => ({
          id: Id.assert(workspace.id),
          slug: workspace.slug,
          name: workspace.name,
          iconUrl: workspace.branding.logos.icon,
          isSelected: vm.isSelected(workspace),
          onSelect: () => vm.select(workspace),
        }))}
        onAddWorkspace={workspaceSignupVm.openWorkspaceSearch}
      />
    )
  },
)
